export default __webpack_public_path__ + "static/media/img_10.217a6f2f.webp";